import { Inject, Injectable } from '@angular/core';
import { AariFitterAppEnvironment } from '@sc/data-access-models';
import { ENV_CONFIG } from '@sc/data-access-environment';

@Injectable({
  providedIn: 'root',
})
export class HorizonsService {
  constructor(@Inject(ENV_CONFIG) protected env: AariFitterAppEnvironment) {
    if (!env || !env.horizons?.dossierBaseUrl) {
      throw new Error('Invalid environment configuration for HorizonsService');
    }
  }

  getHorizonsDossierUrl(horizonsDossierId: string): string {
    return `${this.env.horizons.dossierBaseUrl}/${horizonsDossierId}`;
  }
}
